module.exports = __webpack_public_path__ + "static/media/buffalo.1ae6d868.webp";